import * as React from 'react';
import { PANEL_TEXT_STYLES } from '../constants/text-styles';

/**
 * Lets a subtree override the section-title styling used by the shared section
 * components (SectionCard, TabbedSection, CollapsibleSection) without prop
 * drilling. When no provider is present the components fall back to the default
 * PANEL_TEXT_STYLES.sectionTitle, so every other entity type is unaffected.
 */
const SectionTitleClassNameContext = React.createContext<string | undefined>(undefined);

interface SectionStyleProviderProps {
  /** Tailwind classes applied to every section title within the subtree. */
  sectionTitleClassName: string;
  children: React.ReactNode;
}

export function SectionStyleProvider({
  sectionTitleClassName,
  children,
}: SectionStyleProviderProps) {
  return (
    <SectionTitleClassNameContext.Provider value={sectionTitleClassName}>
      {children}
    </SectionTitleClassNameContext.Provider>
  );
}

/**
 * Returns the section-title class for the current subtree, defaulting to the
 * shared panel style when no SectionStyleProvider is present.
 */
export function useSectionTitleClassName(): string {
  return React.useContext(SectionTitleClassNameContext) ?? PANEL_TEXT_STYLES.sectionTitle;
}
